export enum PracticePermission {
  // CHATS
  READ_CHAT_HEADSTART = "readChatHeadstart",
  WRITE_CHAT_HEADSTART = "writeChatHeadstart",
  READ_CHAT_CLIENTS = "readChatClients",
  WRITE_CHAT_CLIENTS = "writeChatClients",

  // PAGES
  READ_PAGE_LIBRARY = "readPageLibrary",
  WRITE_PAGE_LIBRARY = "writePageLibrary",
  READ_PAGE_AUTH_REQUESTS = "readPageAuthRequests",
  WRITE_PAGE_AUTH_REQUESTS = "writePageAuthRequests",
  READ_PAGE_RBT_REQUESTS = "readPageRbtRequests",
  WRITE_PAGE_RBT_REQUESTS = "writePageRbtRequests",
}

export const groupedPermissions = {
  "Chat: Headstart": {
    read: PracticePermission.READ_CHAT_HEADSTART,
    write: PracticePermission.WRITE_CHAT_HEADSTART,
  },
  "Chat: Clients": {
    read: PracticePermission.READ_CHAT_CLIENTS,
    write: PracticePermission.WRITE_CHAT_CLIENTS,
  },
  "Page: Library": {
    read: PracticePermission.READ_PAGE_LIBRARY,
    write: PracticePermission.WRITE_PAGE_LIBRARY,
  },
  "Page: Auth Requests": {
    read: PracticePermission.READ_PAGE_AUTH_REQUESTS,
    write: PracticePermission.WRITE_PAGE_AUTH_REQUESTS,
  },
  "Page: RBT Requests": {
    read: PracticePermission.READ_PAGE_RBT_REQUESTS,
    write: PracticePermission.WRITE_PAGE_RBT_REQUESTS,
  },
}

export const FULL_PERMISSIONS: PracticePermission[] = Object.values(PracticePermission)

export type UserWithPracticePermissions = {
  id: string;
  name: string;
  email: string;
  permissions: PracticePermission[]
}